import React from 'react';
import {
  FloatingScrollBar,
  FloatingScrollBarBaseProps,
} from '../FloatingScrollBar/FloatingScrollBar';

export interface TableFloatingScrollBarProps
  extends FloatingScrollBarBaseProps {}

export function TableFloatingScrollBar(props: TableFloatingScrollBarProps) {
  return <FloatingScrollBar {...props} dataHook="table-floating-scroll-bar" />;
}
